import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions-col" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_gain_configuration_versions_modal = _resolveComponent("gain-configuration-versions-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_card, { "no-header": "" }, {
      body: _withCtx(() => [
        _createVNode(_component_el_row, { class: "items-stretch broker-row" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(Object.keys($setup.ApiName).find(
                key => $setup.ApiName[key] === $props.configuration.apiName
              )), 1),
                _createElementVNode("h3", {
                  class: "body-1 cursor-pointer mt-1",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openVersionModal && $setup.openVersionModal(...args)))
                }, _toDisplayString(_ctx.$t('currentVersion') + ': ' + $props.configuration.version), 1),
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  content: _ctx.$t('disableApiConnectionNote')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: $setup.form.enabled,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.enabled) = $event)),
                      "active-text": _ctx.$t('enabledCapitalized'),
                      "inactive-text": _ctx.$t('disabledCapitalized'),
                      onChange: $setup.handleChange
                    }, null, 8, ["modelValue", "active-text", "inactive-text", "onChange"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 15 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: $setup.form,
                  rules: $setup.formRules,
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('connectionDetails')), 1)
                      ]),
                      _: 1
                    }),
                    ($setup.props.configuration.apiName !== $setup.ApiName.Etrade)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "mb-0",
                          label: _ctx.$t('dataEndpoint'),
                          prop: "dataEndpoint"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: $setup.form.dataEndpoint,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.dataEndpoint) = $event)),
                              modelModifiers: { trim: true },
                              "validate-event": false,
                              size: "small",
                              onChange: $setup.handleChange
                            }, null, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('clientId'),
                      prop: "clientId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.clientId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.clientId) = $event)),
                          "validate-event": false,
                          size: "small",
                          onChange: $setup.handleChange
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('clientSecretKeyName'),
                      prop: "clientSecretKeyName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.clientSecretKeyName,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.clientSecretKeyName) = $event)),
                          "validate-event": false,
                          size: "small",
                          onChange: $setup.handleChange
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('tokenAcquisitionSettings')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('tokenUrl'),
                      "validate-event": false,
                      prop: "tokenUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.tokenUrl,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.tokenUrl) = $event)),
                          modelModifiers: { trim: true },
                          "validate-event": false,
                          size: "small",
                          onChange: $setup.handleChange
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('scope'),
                      prop: "scope"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.scope,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.scope) = $event)),
                          "validate-event": false,
                          size: "small",
                          onChange: $setup.handleChange
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('grantType'),
                      prop: "grantType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: $setup.form.grantType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.grantType) = $event)),
                          size: "small",
                          onChange: $setup.handleChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.AuthGrantType), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item ?? '',
                                label: item ?? '',
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('responseType'),
                      prop: "responseType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: $setup.form.responseType,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.responseType) = $event)),
                          size: "small",
                          onChange: $setup.handleChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.AuthResponseType), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item ?? '',
                                label: item ?? '',
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 3,
              class: "actions-col-wrapper"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("img", {
                    src: require(`@/assets/images/icons/new/delete.svg`),
                    height: "20",
                    width: "20",
                    class: "action-icon cursor-pointer",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.deleteItem && $setup.deleteItem(...args)))
                  }, null, 8, _hoisted_2),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "large",
                    onClick: $setup.saveItem
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_gain_configuration_versions_modal, {
      modelValue: $setup.showVersionModal,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.showVersionModal) = $event)),
      "configuration-versions": $setup.props.configurationHistory,
      onRestore: $setup.handleRestore,
      onClose: _cache[11] || (_cache[11] = ($event: any) => ($setup.showVersionModal = false))
    }, null, 8, ["modelValue", "configuration-versions", "onRestore"])
  ], 64))
}